const YesIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 1c6.078 0 11 4.922 11 11s-4.922 11-11 11S1 18.078 1 12 5.922 1 12 1z"
        stroke="#4CB260"
        stroke-width="2"
      />
      <path
        d="m5.695 12.296 4.002 4.206 7.998-8.4"
        stroke="#4CB260"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default YesIcon;
